exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/*.mobile-friendly-popper {*/\r\n/*  max-height: 30vh;*/\r\n/*  overflow-y: auto;*/\r\n/*}*/\n@media (max-width: 768px) {\n.mobile-friendly-popper {\r\n    max-height: 600px;\r\n    position: fixed !important;\n}\n}\r\n", ""]);

// exports
